import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import hourlyApi from "@/api/hourlyApi";
import { homeAtom } from "./home";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistSubpageApiInfoAndHeader,
} from "./utils/weatherQueryShared";

const hourlyListAtom = atom<any>([]);
const queryhourlyAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));
    const resData = await hourlyApi.query(newParams);
    const updatedHourList = resData.data.hourList.map((item: any) => ({
      ...item,
      isExpand: false,
    }));
    persistSubpageApiInfoAndHeader(set, resData?.data?.info);
    set(hourlyListAtom, updatedHourList);
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { hourlyListAtom, queryhourlyAtom };
